import {LocaleType} from '../enum/LocaleType'
import {findLocaleTypeFromLanguageTag} from './findLocaleTypeFromLanguageTag'

export function resolveLocaleTypeFromLanguageTag(languageTag: string | undefined | null): LocaleType {
  return findLocaleTypeFromLanguageTag(languageTag) ?? LocaleType.English
}
